import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Button, Modal, Tooltip, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from "react";
import { useActionData, useFetcher, useLoaderData, useParams } from 'react-router-dom';
import { uploadFileFromObject } from "../../../api/common/image-upload";
import { Box, ViewAndDownload } from '../../../components/design';
import { Currency, DatePicker, FieldWrapper, InputWrapper } from "../../../components/inputs";
import { Prompt } from '../../../components/message';
import { ActionError } from '../../../library/classes/exceptions';
import { formats } from '../../../library/constants/formats.js';
import { convertDate } from "../../../library/helpers/dateFormat";
import dayjs from '../../../library/utils/dayjs.js';
import { Message, MessageTypes, PDFUpload } from "../../../ui";
import RecievedFiles from '../../template/receivedFiles.jsx';
import style2 from '.././stepBody.module.scss';
import styles from './quoatation.module.scss';
import { showAlert } from '../../../components/message/alert.jsx';

const calcTotalPrice = (initialPurchase, initialShipping, quantity) => {
    return (((parseFloat(initialPurchase) * parseInt(quantity)) + parseFloat(initialShipping || 0.00)))
}
const useQuotationLineTotals = (initialPurchase, initialShipping, quantity) => {
    const [purchase, setPurchase] = useState(parseFloat(initialPurchase));
    const [shipping, setShipping] = useState(parseFloat(initialShipping));
    const [total, setTotal] = useState(calcTotalPrice(initialPurchase, initialShipping, quantity));

    useEffect(() => {
        setTotal(calcTotalPrice(purchase, shipping, quantity))
        console.log(total);

    }, [purchase, shipping]);
    return {
        purchase,
        shipping,
        total,
        setPurchase,
        setShipping,
        setTotal: (val) => {
            setPurchase((parseFloat(val)) / quantity)
            setShipping(0)
        }
    };
}

const PriceRow = ({ item, onFirstChange, def, date, currency, index }) => {
    const { purchase, shipping, total, setPurchase, setShipping, setTotal } = useQuotationLineTotals(item.price_unit, item.transport_price, item.quantity)
    const userData = JSON.parse(localStorage.getItem('USER'));
    const defaultCurrency = userData.currency.code;
    const disabledAfterDate = date
        ? dayjs(date).isAfter(dayjs().add(5, 'day'))
            ? dayjs(date).subtract(5, 'day').format(formats.backendDateFormat)
            : dayjs().format(formats.backendDateFormat)
        : undefined;

    return (
        <div className={styles.deliveryRow}>
            <div>{item.quantity}</div>
            <div>{date == null ? 'N/A' : convertDate(date)}</div>
            <input type="hidden" name={`[${item.id}]quantity`} value={item.quantity} />
            <div>
                {index == 0 && <FieldWrapper>
                    <DatePicker disabledAfter={disabledAfterDate} name={`[${item.id}]expected_artwork_received_date`} value={def} onChange={(date) => {
                        if (index == 0) {
                            onFirstChange(date)
                        }
                    }} />
                </FieldWrapper>}
                {def ?
                    index != 0 ? <FieldWrapper>
                        <DatePicker disabledAfter={disabledAfterDate} name={`[${item.id}]expected_artwork_received_date`} value={def} onChange={(date) => {
                            if (index == 0) {
                                onFirstChange(date)
                            }
                        }} />
                    </FieldWrapper> : <div></div> :
                    <div></div>}
            </div>
            <div>
                <FieldWrapper>
                    <Currency currency={currency == null ? defaultCurrency : currency?.code} required name={`[${item.id}]purchase_price`} value={purchase} onChange={(val) => { setPurchase(val) }} />
                </FieldWrapper>
            </div>
            <div>
                <FieldWrapper>
                    <Currency currency={currency == null ? defaultCurrency : currency?.code} value={shipping} name={`[${item.id}]shipping_cost`} onChange={(val) => { setShipping(val) }} />
                </FieldWrapper>
            </div>
            <div>
                <FieldWrapper>
                    <Currency currency={currency == null ? defaultCurrency : currency?.code} value={total} name={`[${item.id}]total_price`} onChange={val => setTotal(val)} />
                </FieldWrapper>
            </div>
        </div>
    )
}

PriceRow.propTypes = {
    item: PropTypes.object,
    date: PropTypes.string,
    index: PropTypes.number,
    currency: PropTypes.object,
    onFirstChange: PropTypes.func,
    def: PropTypes.string
}


const infoText = 'When vendor filled Purchase price/piece then Total amount section will be auto calculated and read only. When vendor fills Total price then Per piece and shipping cost will be read only'
const instructions = "To determine this date: \n\n 1. Know Your Deadlines: This is the date by which you need to have the final artwork in hand, based on the delivery deadline provided by the client. \n\n 2. Calculate Production & Shipment Time: Deduct the total days you require for both production and shipment after receiving approval on the artwork proof.\n\n 3. Set Your Receive Date: The result is the latest date you should receive the final ArtWork to meet the client's delivery deadline."

const NewQuotation = () => {
    const { quoatationData, visualData } = useLoaderData()
    const { id } = useParams()
    const actionData = useActionData()
    const [isUploading, setIsUploading] = useState(false)
    const fileUploaderRef = useRef([])
    const [open, setOpen] = useState(false);
    const fetcher = useFetcher();
    const { errors = {} } = fetcher.data || {}
    const inputComment = useRef('')
    const [def, setDef] = useState()

    useEffect(() => {
        setIsUploading(fetcher.json?.action === 'uploadFileQuotation')
    }, [fetcher.data])

    const handleFilesUpload = async () => {
        if (fileUploaderRef.current.length === 0) {
            showAlert('Please select atleast one file')
            return
        }

        setIsUploading(true)
        const promises = fileUploaderRef.current.map(file => uploadFileFromObject(file))
        try {
            const fileIds = await Promise.all(promises)
            fetcher.submit({
                id,
                fileId: fileIds[0],
                comment: inputComment.current,
                action: 'uploadFileQuotation'
            }, {
                method: 'post',
                encType: 'application/json'
            })
            setOpen(false)
        }
        catch (error) {
            message.error(error.message)
            message.error(error.message)
            if (error.message == "Changes in the quotation, please refresh the page.") {
                window.location.reload()
            }
        }
        finally {
            setIsUploading(false)
        }
    }
    // const handleFilesUpload = async () => {
    //     if (fileUploaderRef.current.length === 0) {
    //         alert('Please select atleast one file')
    //         return
    //     }
    //     const promises = fileUploaderRef.current.map(file => uploadFileFromObject(file))
    //     try {
    //         const fileIds = await Promise.all(promises)
    //         const jsonData = { file: fileIds[0], comment: inputComment.current }
    //         const response = await sendPricesFile(id, jsonData)
    //         const { message: msg } = response
    //         message.success(msg);
    //         setOpen(false);
    //     }
    //     catch (error) {
    //         message.error(error.message)
    //         if (error.message == "Changes in the quotation, please refresh the page.") {
    //             window.location.reload()
    //         }

    //     }
    //     // try {
    //     //     const response = await sendPrices(id, finalData)
    //     //     const { message: msg, quoatationData } = response
    //     //     console.log(response);
    //     //     message.success(msg)
    //     // }
    //     // catch (e) {
    //     //     message.error(e.message)
    //     //     throw e
    //     // }
    // }

    const handleCancel = () => {
        if (open && isUploading) return //Prevent popup close while uploading
        setOpen(false);
    };
    const showModal = () => {
        setOpen(true);
    };
    return (
        <div>
            <div className={styles.container}>
                {quoatationData.vendorData?.status === 3 && <Alert message='A request has been sent to Leoprinting for visual.' />}
                {quoatationData.vendorData?.status === 4 && (
                    <>
                        <Alert message="Visual Received" description='Below are the visual received from Leoprinting' />
                        <br />
                        {!!visualData && <div>
                            {visualData.map(({ url, name }) => (
                                <RecievedFiles image={url} name={name} key={url} project_id={quoatationData.item.project_id} item_id={quoatationData.item.id} />
                            ))}
                        </div>
                        }
                        <br />
                        <hr />
                    </>
                )}
                <br />
                <h3>Task For You</h3>
                <div>
                    <fetcher.Form method='post'>
                        <input type="hidden" name='itemId' value={quoatationData.vendorData.id} />
                        <Box header={
                            <div className={styles.deliveryRowHead}>
                                <div>Quantity</div>
                                <div> <Tooltip title="The estimated date for the delivery to be completed." >Deadline Delivery Date <InfoCircleOutlined /></Tooltip></div>
                                <div>Artwork Approved Date <Tooltip title={instructions} overlayStyle={{ maxWidth: '500px', whiteSpace: 'pre-line' }} >
                                    <InfoCircleOutlined />
                                </Tooltip></div>
                                <div>Price / Unit <Tooltip title={infoText} ><InfoCircleOutlined /> </Tooltip></div>
                                <div>Shipping Cost <Tooltip title={infoText} ><InfoCircleOutlined /> </Tooltip></div>
                                <div>Total Amount <Tooltip title={infoText} ><InfoCircleOutlined /> </Tooltip></div>
                            </div>
                        }>
                            {quoatationData.vendorData.item_vendor_quotation_prices.map((value, index) => {
                                return (
                                    <PriceRow def={def} onFirstChange={(def) => {
                                        setDef(def)
                                    }} index={index} currency={quoatationData.vendorData.currency} item={value} enabled={true} key={value.id} date={quoatationData.item.client_expected_delivery_date} />
                                )
                            })}
                        </Box>
                        <InputWrapper label='Comment for Leopriting' name='comment' placeholder="Your message Here..." allowClear textarea />

                        <div className={styles.bottomButton}>
                            <div className={styles.bottomButtonLeft}>
                                <Prompt
                                    title="Request Leoprinting for Visual"
                                    buttonText="Request for Visual"
                                    onConfirm={({ comment = '' }) => {
                                        fetcher.submit({
                                            comment,
                                            action: 'requestVisual'
                                        }, {
                                            method: 'post',
                                            encType: 'application/json'
                                        })
                                    }}
                                    okText="Request Visual"
                                    type='primary'
                                    width={520}
                                    loading={fetcher.json?.action === 'requestVisual'}
                                    disabled={fetcher.state === 'submitting'}
                                    ghost
                                >
                                    <Alert message='Ask Leoprinting for a visual to confirm the quotation and start production' />
                                    <br />
                                    <InputWrapper name="comment" label="Comment" textarea />
                                </Prompt>
                                {/* <Button onClick={() => { setCurrent(3) }} type='primary' ghost>Request for Visual</Button> */}
                            </div>
                            <span className={styles.bottomButtonRight}>
                                <Button type='link' ghost onClick={() => { showModal(true) }} style={{ padding: '4px' }}> <Tooltip title="Upload You Own Quotation in PDF format to Leopriting" >Upload Quotation</Tooltip></Button>|
                                <Button type='primary' htmlType='submit' name='action' value='sendQuotation' loading={fetcher.formData?.get('action') === 'sendQuotation'} disabled={fetcher.state === 'submitting'}> <Tooltip title={'Send Quotation to Leoprinting'} >Send Quotation </Tooltip></Button>
                            </span>
                        </div>
                    </fetcher.Form>
                </div>
            </div>
            <Modal
                title="Upload Quotation"
                open={open}
                onOk={handleFilesUpload}
                onCancel={handleCancel}
                okText="Send"
                okButtonProps={{
                    loading: isUploading,
                }}
                cancelButtonProps={{
                    disabled: isUploading
                }}
            >
                <div className="wrapper clientartwork-wrapper">
                    <div className="main">
                        <div className={`box--white ${style2.wrapper}`}>
                            <div className={style2.content}>
                                {!!actionData && actionData instanceof ActionError && <Message type={MessageTypes.ERROR} message={actionData.message} timeOut={3} />}
                                {actionData === true && <Message type={MessageTypes.SUCCESS} message="File Uploaded Successfully" timeOut={3} />}
                                <div className={styles.uploadBox}>
                                    <div className="main">
                                        <div className="box--white">
                                            <PDFUpload ref={fileUploaderRef} />
                                        </div>
                                    </div>
                                    <br />
                                    <InputWrapper name="comment" label="comment" defaultValue="" textarea allowClear errors={errors} onChange={e => inputComment.current = e.target.value} />
                                </div>
                                <i>Supported formats : PDF</i>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {quoatationData.vendorData.file != null &&
                <div className={styles.stepBox}>
                    <div className={styles.message}>
                        <Alert message='File Shared' description={'Your Quotation File has been shared with leoprinting'}
                            action={
                                <ViewAndDownload project_id={quoatationData.item.project_id}
                                    item_id={quoatationData.item.id}
                                    name={quoatationData.vendorData.file.quotation.url}
                                />
                                // ViewAndDownload
                                // ViewAndDownload
                                // <Link to={getFilePath(quoatationData.item.project_id, quoatationData.item.id, quoatationData.vendorData.file.quotation.url)}><Button icon={<FilePdfOutlined />}>View File</Button></Link>
                            }
                        />



                    </div>

                </div>
            }
        </div>
    )
}

export default NewQuotation;
